module.exports = __webpack_public_path__ + "media/native-apps/motala-453536d8.webp";